/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";

// Images
import symfony from "assets/images/emtay/symfony_logo.png";
import laravel from "assets/images/emtay/laravel_logo.png";
import react from "assets/images/emtay/react_logo.png";
import vue from "assets/images/emtay/vue_logo.png";
import ts from "assets/images/emtay/typescript_logo.png";
import k8s from "assets/images/emtay/k8s_logo.png";
import aws from "assets/images/emtay/aws_logo.png";
import terraform from "assets/images/emtay/terraform_logo.png";

import styles from "assets/scss/emtay.module.scss";

import MKTypography from "../../../components/MKTypography";

// i18n
import { useLanguage } from "i18n";

function Technologies() {
  const { t } = useLanguage();

  return (
    <MKBox component="section" pt={3} pb={8} py={2}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={8}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h4" my={1}>
            {t("technologies.title")}
          </MKTypography>
        </Grid>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://symfony.com/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Symfony
                </MKTypography>
                <MKBox
                  className={styles.technologyLogo}
                  component="img"
                  src={symfony}
                  alt="Symfony"
                  width="100%"
                  opacity={0.7}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://laravel.com/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Laravel
                </MKTypography>
                <MKBox
                  component="img"
                  src={laravel}
                  alt="Laravel"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://react.dev/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  React
                </MKTypography>
                <MKBox
                  component="img"
                  src={react}
                  alt="React"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://vuejs.org/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Vue.js
                </MKTypography>
                <MKBox
                  component="img"
                  src={vue}
                  alt="Vue.js"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>

          <Grid item xs={4} md={3} lg={3}>
            <a href="https://www.typescriptlang.org/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Typescript
                </MKTypography>
                <MKBox
                  className={styles.technologyLogo}
                  component="img"
                  src={ts}
                  alt="Typescript"
                  width="100%"
                  opacity={0.7}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://kubernetes.io/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Kubernetes
                </MKTypography>
                <MKBox
                  component="img"
                  src={k8s}
                  alt="Kubernetes"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a href="https://aws.amazon.com/" target="_blank" rel="noopener noreferrer">
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  AWS
                </MKTypography>
                <MKBox
                  component="img"
                  src={aws}
                  alt="AWS"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>
          <Grid item xs={4} md={3} lg={3}>
            <a
              href="https://developer.hashicorp.com/terraform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.technologiesBlock}>
                <MKTypography variant="h6" my={1} className={styles.technologyTitle}>
                  Terraform
                </MKTypography>
                <MKBox
                  component="img"
                  src={terraform}
                  alt="Vue.js"
                  width="100%"
                  opacity={0.7}
                  className={styles.technologyLogo}
                />
              </div>
            </a>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Technologies;
